// extracted by mini-css-extract-plugin
export var access_link = "collectionUpdate-module--access_link--87376";
export var effective_date = "collectionUpdate-module--effective_date--ddbb4";
export var field_label = "collectionUpdate-module--field_label--b4892";
export var more_info = "collectionUpdate-module--more_info--26ece";